// ============================================================
// MT5 Simulator — landing JS
// Decorative work (countdown, parallax, count-up, reveal) is deferred
// to idle time so it no longer blocks the main thread during load.
// Interactive/layout work (bar-sync, video, carousel) still runs immediately.
// ============================================================

function mt5InitDecor() {

  // ---- 1) Offer countdown ----
  (function(){
    var KEY = "mt5_fifa_end";
    var end = parseInt(localStorage.getItem(KEY) || "0", 10);
    var now = Date.now();
    if (!end || end < now) { end = now + 3*24*60*60*1000; localStorage.setItem(KEY, end); }
    var el = document.getElementById("mt5-countdown");
    function pad(n){ return n < 10 ? "0"+n : ""+n; }
    function tick(){
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d/3600000);
      var m = Math.floor((d%3600000)/60000);
      var s = Math.floor((d%60000)/1000);
      if (el) el.textContent = pad(h)+":"+pad(m)+":"+pad(s);
    }
    tick(); setInterval(tick, 1000);
  })();

  // ---- 2) MacBook parallax (rect cached on enter — no per-move reflow) ----
  (function(){
    var mac = document.querySelector('.mt5-macbook');
    if (!mac) return;
    var rect;
    mac.addEventListener('mouseenter', function(){ rect = mac.getBoundingClientRect(); });
    mac.addEventListener('mousemove', function(e){
      if (!rect) rect = mac.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      mac.style.transform = 'perspective(1200px) rotateX(' + (-y*10).toFixed(2) + 'deg) rotateY(' + (x*10).toFixed(2) + 'deg)';
    });
    mac.addEventListener('mouseleave', function(){
      rect = null; // re-measure next enter (handles scroll/resize)
      mac.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg)';
    });
  })();

  // ---- 3) Count-up numbers + scroll reveal ----
  (function(){
    var els = document.querySelectorAll('.count-up');
    if (!els.length) return;
    function fmt(el, val){
      var dec = parseInt(el.dataset.decimals || '0', 10);
      var sep = el.dataset.separator || '';
      var suf = el.dataset.suffix || '';
      var pre = el.dataset.prefix || '';
      var s = dec > 0 ? val.toFixed(dec) : Math.floor(val).toString();
      if (sep && dec === 0) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      el.textContent = pre + s + suf;
    }
    function animate(el){
      if (el.dataset.done) return;
      el.dataset.done = '1';
      var target = parseFloat(el.dataset.count);
      var duration = 1800;
      var start = null;
      function step(ts){
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        fmt(el, target * eased);
        if (p < 1) requestAnimationFrame(step);
        else fmt(el, target);
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting){ animate(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      els.forEach(function(el){ io.observe(el); });
    } else {
      els.forEach(animate);
    }

    (function(){
      var revealGroups = [
        { sel: '.mt5-brand', parent: true },
        { sel: '.mt5-bullets .b', parent: true },
        { sel: '.mt5-steps .s', parent: true },
        { sel: '.mt5-vids .v', parent: true },
        { sel: '.mt5-stats .st', parent: true },
        { sel: '.mt5-cmp .col', parent: true },

        { sel: '.mt5-tst .t', parent: true },
        { sel: '.mt5-price .p', parent: true },
        { sel: '.mt5-brokers .logo', parent: true },
        { sel: '.mt5-sec h2', parent: false },
        { sel: '.mt5-sec .lede', parent: false },
        { sel: '.mt5-com .card', parent: false, scale: true },
        { sel: '.mt5-macbook-titlebar', parent: false },
        { sel: '.mt5-brokers .lbl', parent: false },
        { sel: '.mt5-cta', parent: false }
      ];
      var observed = [];
      revealGroups.forEach(function(g){
        var items = document.querySelectorAll(g.sel);
        items.forEach(function(el, idx){
          if (g.parent && el.parentElement) {
            var parent = el.parentElement;
            if (!parent.classList.contains('reveal-parent')) {
              parent.classList.add('reveal-parent');
              observed.push(parent);
            }
            el.classList.add('reveal', 'reveal-delay-' + (idx + 1));
          } else {
            el.classList.add(g.scale ? 'reveal-scale' : 'reveal');
            observed.push(el);
          }
        });
      });
      var revealObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting){
            en.target.classList.add('visible');
            revealObserver.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      observed.forEach(function(el){ revealObserver.observe(el); });
    })();
  })();

}

// Run all decorative init once the browser is idle (capped at 2s).
if ('requestIdleCallback' in window) {
  requestIdleCallback(mt5InitDecor, { timeout: 4000 });
} else {
  window.addEventListener('load', mt5InitDecor);
}


// ============================================================
// Interactive / layout — runs immediately (NOT deferred)
// ============================================================



// ---- Testimonial video cards: click to play, pause when scrolled away ----
(function () {
  var cards = document.querySelectorAll('.mt5-vids .v');
  if (!cards.length) return;
  var all = [];

  cards.forEach(function (card) {
    var v = card.querySelector('video');
    if (!v) return;
    all.push({ card: card, v: v });

    card.addEventListener('click', function () {
      if (!v.paused) { v.pause(); card.classList.remove('playing'); return; }
      all.forEach(function (o) {
        if (o.v !== v) { o.v.pause(); o.card.classList.remove('playing'); }
      });
      v.muted = false;
      var p = v.play();
      if (p && p.catch) {
        p.then(function () { card.classList.add('playing'); })
         .catch(function () { v.muted = true; v.play(); card.classList.add('playing'); });
      } else {
        card.classList.add('playing');
      }
    });
  });

  if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) return;
        var v = en.target.querySelector('video');
        if (v && !v.paused) { v.pause(); en.target.classList.remove('playing'); }
      });
    }, { threshold: 0.25 });
    cards.forEach(function (c) { vo.observe(c); });
  }
})();

// ---- Testimonial video carousel (dots / arrows / swipe) ----
(function () {
  var track = document.querySelector('.mt5-vids');
  var nav = document.querySelector('.mt5-vids-nav');
  if (!track || !nav) return;

  var cards = [].slice.call(track.querySelectorAll('.v'));
  var dotWrap = nav.querySelector('.mt5-vids-dots');
  var arrows = [].slice.call(nav.querySelectorAll('.mt5-vids-arrow'));
  var current = 0;

  cards.forEach(function (_, i) {
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Go to video ' + (i + 1));
    b.addEventListener('click', function () { go(i); });
    dotWrap.appendChild(b);
  });
  var dots = [].slice.call(dotWrap.children);

  function nearest() {
    var r = track.getBoundingClientRect();
    var mid = r.left + r.width / 2;
    var best = 0, bd = Infinity;
    cards.forEach(function (el, i) {
      var er = el.getBoundingClientRect();
      var d = Math.abs(er.left + er.width / 2 - mid);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }

  function paint(i) {
    current = i;
    dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
    arrows.forEach(function (a) {
      var dir = parseInt(a.dataset.dir, 10);
      a.disabled = (dir < 0 && i === 0) || (dir > 0 && i === cards.length - 1);
    });
  }

  function go(i) {
    i = Math.max(0, Math.min(cards.length - 1, i));
    cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    paint(i);
  }

  arrows.forEach(function (a) {
    a.addEventListener('click', function () { go(current + parseInt(a.dataset.dir, 10)); });
  });

  var raf;
  track.addEventListener('scroll', function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { paint(nearest()); });
  }, { passive: true });

  // swipe must not fire the video play handler
  var sx = 0, sy = 0, moved = false;
  track.addEventListener('touchstart', function (e) {
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
  }, { passive: true });
  track.addEventListener('touchmove', function (e) {
    if (Math.abs(e.touches[0].clientX - sx) > 10 ||
        Math.abs(e.touches[0].clientY - sy) > 10) moved = true;
  }, { passive: true });
  track.addEventListener('click', function (e) {
    if (moved) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  paint(0);
  window.addEventListener('resize', function () { paint(nearest()); });
})();